import { render, staticRenderFns } from "./BeaconCarriedList.vue?vue&type=template&id=45a13c89&"
import script from "./BeaconCarriedList.vue?vue&type=script&lang=ts&"
export * from "./BeaconCarriedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports